import apiBase from './apiBase';

function fetchNext(url, urls, success, failure, { contentType, method, body }) {
  function tryNext(err) {
    if (urls.length) {
      return fetchNext(urls[0], urls.slice(1), success, failure, { contentType, method, body });
    } else {
      failure(err);
    }
  }

  if (contentType === 'img') {
    let img = new Image();
    img.crossOrigin = 'anonymous'; // don't send cookies, but do send Origin: header
    img.addEventListener('load', (e) => {
      success(img);
    });
    img.addEventListener('error', tryNext);
    img.src = url; //s.shift();
  } else if (contentType === 'external') {
    // This will need to use JSONP in some fashion (either dynamic function,
    // or some sort of global plugin namespace in order to work, since
    // CORS prevents us from just loading the file via xhr
    throw new Error('External Script support not allowed in the browser');
  } else {
    let request = new XMLHttpRequest();
    const requestMethod = method || 'GET';
    if (requestMethod !== 'GET') request.withCredentials = true;
    request.open(requestMethod, url, true);
    if (body) request.setRequestHeader('Content-Type', 'application/json');

    if (contentType === 'binary') request.responseType = 'arraybuffer';
    request.onload = (xhr) => {
      let response = request.response;

      if (request.status >= 200 && request.status < 400) {
        if (contentType === 'json') response = JSON.parse(response);
        success(response);
      } else {
        tryNext(request);
      }
    };

    request.onerror = tryNext;
    request.send(body);
  }
}

const callApi = apiBase(fetchNext);

export default callApi;



// WEBPACK FOOTER //
// ./src/store/api.js